'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _discounts = require('./discounts');

var _discounttype = require('./discounttype');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.discount', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('general.discounts', {
        url: '/discounts?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'discounts'
            }
        },
        //reloadOnSearch : false,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.localStorage.getItem('pageSize'), squash: false, dynamic: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true
                //specificDateFilter : {value:'',squash: true, dynamic: true}
            } },
        ncyBreadcrumb: {
            label: '{{"Discounts" | translate}}'
        }
    }).state('general.discounts.discounttype', {
        url: '/discounttype/{id:int}',
        views: {
            'main@root': {
                component: 'discounttype'
            }
        },
        resolve: {
            discounttype: ["$stateParams", "discounttypeService", function discounttype($stateParams, discounttypeService) {
                'ngInject';

                return discounttypeService.get(parseInt($stateParams.id));
            }]
        },
        //loadOnSearch : false,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.localStorage.getItem('pageSize'), squash: true, dynamic: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true },
            noReloadFilter: { squash: true }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.discounttype.name}}'
        }
    }).state('seller.discounts.discounttype', {
        url: '/discounttype/{id:int}?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'discounttype'
            }
        },
        resolve: {
            discounttype: ["$stateParams", "discounttypeService", function discounttype($stateParams, discounttypeService) {
                'ngInject';

                return discounttypeService.get(parseInt($stateParams.id));
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            pageSize: { value: '24', squash: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true },
            filter: { value: '', squash: true },
            noReloadFilter: { squash: true }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.discounttype.name}}'
        }
    });
}]).component('discounts', _discounts.discountsComponent).component('discounttype', _discounttype.discounttypeComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/discount/index.js
// module id = 928
// module chunks = 0